module.exports = __webpack_public_path__ + "img/d270798.png";